var config = require('../../../../../../config/clientConfig.json');

export { config };
